import seed        from '@/pods/app/seed';
import validateKey from './validate-key';

var methods = {
    capitalize(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    },

    pluralize(n, word) {
        var _ = this;

        return _.niceNumber(n) + ' ' + word + (Math.abs(n) === 1 ? '' : 's');
    },

    niceNumber(n) {
        n = Math.abs(n);

        switch (n) {
          case 1:  return 'one';
          case 2:  return 'two';
          case 3:  return 'three';
          case 4:  return 'four';
          case 5:  return 'five';
          case 6:  return 'six';
          case 7:  return 'seven';
          case 8:  return 'eight';
          case 9:  return 'nine';
          case 10: return 'ten';
          case 11: return 'eleven';
          case 12: return 'twelve';
          case 13: return 'thirteen';
          case 14: return 'fourteen';
          case 15: return 'fiveteen';
          case 16: return 'sixteen';
          case 17: return 'seventeen';
          case 18: return 'eightteen';
          case 19: return 'nineteen';
          case 20: return 'twenty';
          default: return n;
        }
    },

    showAddPeopleModal() {
        var _ = this;

        _.$refs.addPeopleModal.show = true;
    },

    showAddToCampaignModal() {
        var _ = this;

        _.$refs.addToCampaignModal.show = true;
    },

    showAddFunnelModal() {
        var _ = this;

        _.$refs.addFunnelModal.show = true;
    },

    showActivationModal(feature) {
        var _ = this;

        _.$refs.activationModal.show = true;

        if (typeof feature === 'string') {
            _.$refs.activationModal.feature = feature;
        }
    },

    showCourseModal() {
        var _ = this;

        _.$refs.courseModal.show = true;
    },

    editStep(funnel, step) {
        var _ = this;

        _.$refs.editStepModal.funnel = funnel;
        _.$refs.editStepModal.step = step;
        _.$refs.editStepModal.show = true;
    },

    savePerson(person) {
        var _ = this;

        _.app.requester.request({
            controller: 'people',
            action: 'save',
            person: person
        });
    },

    saveFunnel(funnel) {
        var _ = this;

        _.app.requester.request({
            controller: 'funnels',
            action: 'save',
            funnel: funnel
        });
    },

    checked(item) {
        return /t|1/.test(item);
    },

    getSetting(name) {
        var _ = this;

        return _.settings.find(function(setting) {
            return setting.name === name;
        });
    },

    setColumns(done) {
        var _ = this,
            columns = _.getSetting('columns');

        if (columns && typeof columns.value !== 'undefined') {
            _.columns = columns.value;
            done();
        } else {
            _.requester.request({
                controller: 'settings',
                action: 'save',
                setting: {
                    name: 'columns',
                    value: seed.columns
                }
            }, function(err, data) {
                if (data) {
                    _.columns = _.getSetting('columns');
                }

                done();
            });
        }
    },

    setSubscription(newKey) {
        var _ = this,
            setting = _.getSetting('activation'),
            activation = setting ? setting.value : undefined;

        _.subscription = validateKey(newKey || activation);

        return _.subscription;
    },

    findById(collection, personId) {
        return collection.find(function(item) {
            return item.id + '' === personId + '';
        });
    }
};

export default methods;
